import { useEffect, useState } from "react";
import { ArrowUpRight } from "lucide-react";
import api from "../lib/api";
import { Reveal } from "../components/Reveal";
import Newsletter from "../components/Newsletter";
import { useSEO } from "../lib/useSEO";

export default function Produtos() {
  useSEO({ title: "Produtos", description: "Mentoria, comunidade e materiais para acelerar a sua saída do automático." });
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/products").then((r) => setProducts(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="produtos-page">
      <div className="mx-auto max-w-7xl px-6 py-20 lg:px-12 lg:py-32">
        <Reveal>
          <p className="text-xs font-semibold uppercase tracking-[0.25em] text-gold">Produtos</p>
          <h1 className="mt-6 font-serif text-5xl text-zinc-100 sm:text-6xl">Ferramentas de evolução</h1>
          <p className="mt-6 max-w-xl text-base leading-relaxed text-zinc-400">
            Mentoria, comunidade e materiais para acelerar a sua saída do automático.
          </p>
        </Reveal>

        {loading ? (
          <p className="mt-20 font-serif text-zinc-500" data-testid="products-loading">Carregando…</p>
        ) : (
          <div className="mt-20 grid gap-10 md:grid-cols-2 lg:grid-cols-3">
            {products.map((product, i) => (
              <Reveal key={product.id} delay={i * 0.1}>
                <div className="group flex h-full flex-col border border-gold/15 bg-[#0a0a0a] transition-all duration-500 hover:-translate-y-1 hover:border-gold/40 hover:shadow-[0_0_40px_rgba(212,175,55,0.12)]" data-testid={`product-card-${i}`}>
                  <div className="hairline-frame relative aspect-[4/3] overflow-hidden">
                    {product.image_url && (
                      <img src={product.image_url} alt={product.name} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                    )}
                    <div className="absolute inset-0 bg-gradient-to-t from-[#0a0a0a] via-transparent to-transparent" />
                  </div>
                  <div className="flex flex-1 flex-col p-8">
                    <h2 className="font-serif text-2xl text-zinc-100">{product.name}</h2>
                    <p className="mt-4 flex-1 text-sm leading-relaxed text-zinc-400">{product.description}</p>
                    <div className="mt-8 flex items-center justify-between border-t border-gold/10 pt-6">
                      <span className="font-serif text-lg text-gold" data-testid={`product-price-${i}`}>{product.price_label}</span>
                      <a
                        href={product.checkout_url}
                        target="_blank"
                        rel="noreferrer"
                        className="flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-gold transition-transform hover:-translate-y-0.5"
                        data-testid={`product-buy-${i}`}
                      >
                        Adquirir <ArrowUpRight size={14} />
                      </a>
                    </div>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        )}
      </div>
      <Newsletter />
    </div>
  );
}
